import styled$1, { css } from 'styled-components';
import { colorSet } from '@ccg/core';
import '@4rk/modular-system';
import '../../styles/typography.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import { getTransitionProperty } from '../../styles/transitions.js';

const StyledLogo = styled$1.svg`
  display: ${props => props.inline ? 'inline-block' : 'block'};
  width: auto;

  ${({
  fillColor
}) => fillColor && css(["fill:", ";"], colorSet(fillColor))}

  ${({
  transition
}) => transition && transition.property && css(["", ""], getTransitionProperty(transition.property, transition.delay || ''))}
`;

const Logo = ({
  inline,
  className,
  fillColor,
  transition
}) => /*#__PURE__*/React$1.createElement(StyledLogo, {
  inline: inline,
  className: className,
  width: "291",
  height: "49",
  viewBox: "0 0 291 49",
  fillColor: fillColor,
  transition: transition
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M0 46.829h30.524v-8.124H9.293V0H0zM40.699 46.829h10.175V0H40.699zM85.812 48.865c8.67 0 14.932-3.042 17.97-5.441V23.419h-19.22v7.65h10.907v7.192c-2.145 1.383-5.454 2.583-9.656 2.583-10.46 0-15.466-7.378-15.466-16.412 0-9.036 5.632-16.133 14.573-16.133 5.543 0 8.938 2.12 11.175 4.792l5.9-6.27C98.418 2.95 93.323 0 84.919 0c-13.321 0-23.87 9.958-23.87 24.432 0 14.108 9.834 24.433 24.763 24.433M139.597 30.032l-4.686-12.982-1.648-4.998-1.644 4.998-4.676 12.982h12.654zM128.927 0h8.664l17.066 46.829h-8.97l-3.335-9.22h-18.14l-3.319 9.22h-8.97L128.926 0h.001zM162.797 46.829h30.524v-8.124h-21.23V0h-9.294zM218.899 48.865c11.14 0 19.192-6.46 19.192-18.817V0h-9.55v29.769c0 7.208-3.464 10.576-9.734 10.576-6.367 0-9.832-3.368-9.832-10.576V0h-9.549v30.048c0 12.357 7.958 18.817 19.474 18.817M273.065 21.073l15.9 25.756h-10.261l-11.315-17.733-11.167 17.733h-9.992l15.582-25.577L248.907 0h10.258l8.503 13.244L276.119 0h9.813z"
}));

Logo.propTypes = {
  inline: PropTypes$1.bool,
  className: PropTypes$1.string,
  fillColor: PropTypes$1.string,
  transition: PropTypes$1.shape()
};
Logo.defaultProps = {
  inline: false,
  className: '',
  fillColor: 'color',
  transition: null
};

export default Logo;
